import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";

import MenuItem from "@mui/material/MenuItem";
import { BUTTONS, whatsappNumber } from "./constants";
import { useNavigate } from "react-router";
import {
  isLoggedIn,
  logOut,
  UserContext,
} from "../../setup/context/authContext";
import { LogoutButton } from "../logout";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { AuthConfig } from "../../setup/context/config/authConfig";
import { getBasicUserDetailsById } from "../../setup/api/services/user";
import {
  IUserInfoResponse,
  IUserInfoResponseData,
} from "../../setup/api/services/user/models";
import { DarkLogo, WhiteLogo } from "../common/logo";
import { LOGIN_SECTION_ID } from "../../pages/contract/constants";
import styles from "./styles.module.css";
import { CUSTOMER_SERVICE } from "../../pages/authentication/signup/constants";
import { IUser } from "../../setup/api/services/auth/models";
import { ROUTES } from "../../setup/constants";
import { CSSProperties, useCallback, useEffect, useState } from "react";
import { getOrganization } from "../../setup/api/services/organization";
import { useOrganizationCode } from "../../setup/util/extractOrganizationCode";
import { useTranslation } from "react-i18next";
import { useMultiCashoutEnabled } from "../../hooks/useMultiCashoutEnabled";
export interface UserInfo extends IUser {
  webView?: boolean;
}
interface Props {
  isAdmin: boolean;
  adminOrgEnabled?: boolean;
}

export const NavBar = ({ isAdmin, adminOrgEnabled }: Props) => {
  const userToken = AuthConfig.getToken();
  const [organization, setOrganization] = useState<any>(null);
  const { isMultiCashoutEnabled } = useMultiCashoutEnabled();

  const organizationCode = useOrganizationCode(userToken);

  const fetchOrganization = useCallback(async () => {
    if (!organizationCode) return;
    const response = await getOrganization(
      organizationCode as unknown as string
    );
    setOrganization(response.data);
  }, [organizationCode]);

  useEffect(() => {
    if (organizationCode) {
      fetchOrganization();
    }
  }, [fetchOrganization, organizationCode]);

  const userId = AuthConfig.getUserInfo()?.id;
  const [userDetails, setUserDetials] = useState<
    IUserInfoResponseData | undefined
  >(undefined);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pages, setPages] = useState<{ label: string; route: string }[]>();
  const [navBarStyle, setNavBarStyle] = useState<CSSProperties>({
    background: "#FFFFFF",
  });
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const fetchUserBasicInfo = useCallback(async () => {
    try {
      const response: IUserInfoResponse = await getBasicUserDetailsById(userId);
      if (response) {
        setUserDetials(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [userId]);

  useEffect(() => {
    fetchUserBasicInfo().catch(console.error);
  }, [fetchUserBasicInfo]);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (route: string) => {
    setAnchorElNav(null);
    navigate(route);
  };
  useEffect(() => {
    const loggedIn = isLoggedIn(); // ✅ call it once

    if (loggedIn === true) {
      const NAVBAR_ITEMS = [
        { label: "الرئيسية", route: ROUTES.HOME },
        { label: "معاملاتي", route: ROUTES.CONTRACTS_LIST },
        { label: "معاملاتي v2", route: ROUTES.CONTRACTS_LIST_V2 },
        ...(isAdmin
          ? [
              ...(adminOrgEnabled
                ? [{ label: "المنظمات", route: ROUTES.ORGANIZATIONS }]
                : []),
              { label: "كل المستخدمين", route: ROUTES.USERS_MANAGEMENT },
              { label: "طلبات التسوية", route: ROUTES.SETTLEMENTS },
              { label: "طلبات التحويل", route: ROUTES.CASHOUTS },
              ...(isMultiCashoutEnabled
                ? [
                    {
                      label: "طلبات التحويل المتعدد",
                      route: ROUTES.MULTI_CASHOUTS,
                    },
                  ]
                : []),
              { label: "طلبات السحب", route: ROUTES.WITHDRAWS },
              { label: "تم التحويل", route: ROUTES.COMPLETED_TRANSFERS },
              { label: "إعدادات", route: ROUTES.SETTINGS },
              { label: `${t("lbl_alerts_nav")}`, route: ROUTES.ALERTS },
              {
                label: `${t("lbl_advertisement")}`,
                route: ROUTES.ADVERTISEMENT,
              },
            ]
          : []),
      ];

      setPages(NAVBAR_ITEMS);
      setNavBarStyle({
        background: "#1B242D",
        color: "#FFFFFF",
      });
    } else {
      setPages([]);
      setNavBarStyle({
        background: "#FFFFFF",
      });
    }
  }, [isAdmin, adminOrgEnabled, t, isMultiCashoutEnabled]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const onSignOutclick = () => {
    logOut();
    handleMenuClose();
    window.location.reload();
  };
  const onLoginClick = () => {
    const elmntToView = document.getElementById(LOGIN_SECTION_ID);
    elmntToView && elmntToView.scrollIntoView();
  };
  const pathName = window.location.pathname;
  const isContractLocation = () => {
    return pathName.includes("contract");
  };
  const menuId = "primary-account-menu";
  const renderMenu = (
    <Menu
      dir="rtl"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      style={{ width: "320px" }}
      open={isMenuOpen}
      onClose={handleMenuClose}>
      <MenuItem onClick={onSignOutclick}>
        <LogoutButton />
        {BUTTONS.LOGOUT}
      </MenuItem>
    </Menu>
  );

  return (
    <UserContext.Consumer>
      {({ isLoggedIn }) => (
        <>
          <AppBar position="static" style={navBarStyle}>
            <Container maxWidth="xl">
              <Toolbar disableGutters>
                {isLoggedIn() ? (
                  <WhiteLogo
                    sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
                  />
                ) : (
                  <DarkLogo
                    sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
                  />
                )}

                {isLoggedIn() && (
                  <Box
                    sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      style={{ color: "#FFFFFF" }}
                      onClick={handleOpenNavMenu}>
                      <MenuIcon />
                    </IconButton>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorElNav}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      open={Boolean(anchorElNav)}
                      onClose={handleCloseNavMenu}
                      sx={{
                        display: { xs: "block", md: "none" },
                      }}>
                      {pages?.map((page) => (
                        <MenuItem
                          key={page.label}
                          onClick={() => {
                            handleCloseNavMenu(page.route);
                          }}>
                          <Typography textAlign="center">
                            {page.label}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                )}
                {isLoggedIn() ? (
                  <WhiteLogo
                    sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
                  />
                ) : (
                  <DarkLogo
                    sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
                  />
                )}
                <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                  {pages?.map((page) => (
                    <Button
                      key={page.label}
                      onClick={() => {
                        handleCloseNavMenu(page.route);
                      }}
                      sx={{ my: 2, color: "#FFFFFF", display: "block" }}>
                      {page.label}
                    </Button>
                  ))}
                </Box>
                {isLoggedIn() ? (
                  <Box sx={{ p: 1, display: "flex" }} alignItems={"center"}>
                    <a
                      className={styles.mobile_wrapper}
                      target="blank"
                      href={`https://wa.me/${whatsappNumber}`}>
                      <Box display={"flex"} alignItems={"center"}>
                        <Box
                          component="img"
                          src="/assets/images/svg/whatsapp.svg"
                        />
                        <Typography dir="ltr" className={styles.mobileNumber}>
                          {CUSTOMER_SERVICE}
                        </Typography>
                      </Box>
                    </a>
                    <IconButton
                      size="large"
                      edge="end"
                      aria-label="account of current user"
                      aria-controls={menuId}
                      aria-haspopup="true"
                      onClick={handleProfileMenuOpen}
                      color="inherit">
                      <AccountCircle />
                    </IconButton>
                  </Box>
                ) : (
                  isContractLocation() && (
                    <Box
                      sx={{
                        flexGrow: 1,
                        display: { xs: "flex", md: "none", lg: "none" },
                      }}
                      className={styles.login_header}>
                      <Button
                        variant="contained"
                        onClick={onLoginClick}
                        size="small">
                        {BUTTONS.LOGIN}
                      </Button>
                    </Box>
                  )
                )}
                {organization && (
                  <img
                    src={organization.logoUrl}
                    alt="organization logo"
                    className={styles["img"]}
                  />
                )}
              </Toolbar>
            </Container>
          </AppBar>
          {renderMenu}
        </>
      )}
    </UserContext.Consumer>
  );
};
